import { moduleContent } from "./module-content"
import { moduleContentPl } from "./module-content-pl"

// Define module type
export interface QuickStartModule {
  id: string
  title: string
  description: string
  image?: any
  sectionId: string
  sectionTitle: string
  sectionTitleTranslated: string
  content: string
}

export const getUniqueSections = (): string[] => {
  const sections = new Set<string>()

  Object.values(moduleContent).forEach((instructionSets) => {
    if (
      instructionSets.content.length > 0 &&
      instructionSets.content[0].sectionRaw
    ) {
      sections.add(instructionSets.content[0].sectionRaw)
    }
  })

  return Array.from(sections)
}

// Get modules for a specific section
export const getModulesForSection = (
  sectionName: string,
  language: string
): string[] => {
  return Object.keys(
    language === "pl" ? moduleContentPl : moduleContent
  ).filter((moduleId) => {
    const instructionSets = (
      language === "pl" ? moduleContentPl : moduleContent
    )[moduleId].content
    return (
      instructionSets.length > 0 &&
      instructionSets[0].sectionRaw === sectionName
    )
  })
}

export const getUniqueSliderSections = () => {
  const sections = new Map<string, { id: string; title: string }>()

  Object.entries(moduleContent).forEach(([_, instructionSets]) => {
    if (
      instructionSets.content.length > 0 &&
      instructionSets.content[0].sectionRaw
    ) {
      const sectionTitle = instructionSets.content[0].sectionRaw
      const sectionId = sectionTitle
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]+/g, "")

      sections.set(sectionId, {
        id: sectionId,
        title: sectionTitle,
      })
    }
  })

  return Array.from(sections.values())
}

export const getAllModules = (language: string): QuickStartModule[] => {
  const modules: QuickStartModule[] = []
  const sections = getUniqueSliderSections()

  Object.entries(language === "pl" ? moduleContentPl : moduleContent).forEach(
    ([moduleId, instructionSets]) => {
      if (instructionSets.content.length > 0) {
        const sectionTitle = instructionSets.content[0].sectionRaw
        const sectionTitleTranslated = instructionSets.content[0].section
        const section = sections.find((s) => s.title === sectionTitle)

        if (section) {
          // Extract clean title from instruction set title
          const title = instructionSets.content[0].title.split(":")[0]

          modules.push({
            id: moduleId,
            title: title,
            description: instructionSets.content[0].steps[0],
            sectionId: section.id,
            sectionTitle: sectionTitle,
            sectionTitleTranslated: sectionTitleTranslated,
            image: instructionSets.image,
            content: instructionSets.content.toString(),
          })
        }
      }
    }
  )

  return modules
}

export const getFeaturedData = (sectionName: string, language: string) => {
  const allModules = getAllModules(language)
    .filter((module) => module.sectionTitle !== sectionName)
    .sort(() => Math.random() - 0.5)
    .slice(0, 4)
  return allModules
}
